<!--suppress ALL -->
<template>
  <div class="container">
    <div class="link-to-2d" v-if="type != 3 && env !== 'web'">
      <div class="item"  @click="madeCustom(false)">
        <img class="ic" src="../../assets/img/ic_fangan@2x.png"/>
        <div>调整方案</div>
      </div>
      <div class="item" @click="madeCustom(true)">
        <img class="ic" src="../../assets/img/ic_again@2x.png"/>
        <div>重新定制</div>
      </div>
    </div>

    <div class="header">
      <img class="back" @click="goBack" src="../../assets/img/ic_header_back2.png"/>
      <img class="back-home" @click="isInApp ? backMainActivity() : toMyHome()" src="../../assets/img/goods_detail/ic_home.png"/>
      <img class="img a1" v-if="colorInd>=0" :src="imgDomain + colorList[colorInd].product_img"/>
      <img class="img a2" v-else-if="standardInd>=0" :src="imgDomain + standardList[standardInd].img"/>
      <img class="img a3" v-else-if="detail.info&&detail.info.image" :src="imgDomain + detail.info.image"/>
      <img class="img a3" v-else-if="detail.scheme_pic" :src="imgDomain + detail.scheme_pic"/>
    </div>

    <div class=""></div>

    <div class="content-container">
      <img v-if="type===1||type===2" class="icon-edit" src="../../assets/img/icon_edit.png"/>
      <div class="info">
        <div class="name">{{ detail.info.name || detail.scheme_name }}</div>
        <div class="color">{{ colorInd >= 0 ? colorList[colorInd].color_name : detail.info.color_name || detail.color_name }}</div>
        <div class="price">
          <span class="red"><span class="yun">￥</span>{{ singlePrice }}</span>

          <span class="gray" v-if="showOriginPrice">
            <span class="yun">￥</span>{{ originPrice }}
          </span>

        </div>
        <div class="coupon-list" v-if="couponList.length>0">
          <span class="attr black label">优惠活动</span>
          <div class="coupon-container">
            <div v-for="(item, index) in couponList" class="coupon" @click="showCoupon(item)">
              <img src="../../assets/img/goods_detail/coupon_head.png" alt>
              <img class="tail" src="../../assets/img/goods_detail/coupon_tail.png" alt>
              <div class="coupon-body">{{item.name}}</div>
            </div>
          </div>
        </div>
        <div class="record">
          <span v-if="![null, undefined].includes(detail.info.views) && ![null, undefined].includes(detail.info.sales)">{{ detail.info.views }} 浏览 | 已售 {{ detail.info.sales }}</span>
          <div/>
          <div>
            <img class="ic" @click="collectProduct" v-if="detail.is_collect==1" src="../../assets/img/ic_sc_selected@2x.png"/>
            <img class="ic" @click="collectProduct" v-else src="../../assets/img/ic_houseGoodsDetail_sc@2x.png"/>

            <img class="ic" v-if="env" @click="shareProduct" src="../../assets/img/ic_houseGoodsDetail_share@2x.png"/>
          </div>
        </div>
      </div>
      <div class="deploy">
        <div class="box" v-if="colorList.length">
          <div class="attr black">选择花色</div>
          <div class="main">
            <div class="list">
              <div class="item"
                   v-for="(item,index) in colorList"
                   :class="{'on': preSelectColor(detail.info.color_id == item.color_id, index, item.standard_id)}"
                   @click="selectColor(index, item.standard_id)"
                   :key="index"
                   v-if="isMoreColor||index<4">
                <img class="img" :src="imgDomain + item.origin_img_src"/>
                <div class="name">{{ item.color_name }}</div>
              </div>
            </div>
            <div v-if="colorList.length>4" class="more" :class="{'on':isMoreColor}" @click="isMoreColor=!isMoreColor"/>
          </div>
        </div>
        <div class="box" v-if="standardList.length">
          <div class="attr black">选择规格</div>
          <div class="main">
            <div class="list">
              <div class="item"
                   v-for="(item,index) in standardList"
                   :class="{'on': preSelectStander(detail.info.standard_id == item.standard_id, index, item.stocks),'disable': !item.stocks }"
                   :key="index"
                   v-if="isMoreColor||index<4"
                   @click="getColorStandardInd(index, item.stocks)">
                <img class="img" :src="imgDomain + item.img"/>
                <div class="name">{{ item.name }}</div>
              </div>
            </div>
            <div v-if="standardList.length>4" class="more" :class="{'on':isMoreColor}" @click="isMoreColor=!isMoreColor"/>
          </div>
        </div>
        <div class="box">
          <div class="attr black">购买数量</div>
          <div class="main">
            <div class="count-box">
              <div class="bt" v-if="num>1" @click="num--">-</div>
              <div class="bt" v-else>-</div>
              <div class="val">{{ num }}</div>
              <div class="bt" @click="num++">+</div>
            </div>
          </div>
        </div>
        <div class="box" v-if="deliver_info_selected">
          <div class="attr black">发货周期</div>
          <div class="main">
           <div class="text">{{deliver_info_selected}}</div>
           <div class="text">
<!--             <span style="color: red">*</span>-->
             具体以您与客服沟通确定的送货安装时间为准
           </div>
          </div>
        </div>
      </div>
      <div class="remarks">
        <div class="item">
          <img class="ic" src="../../assets/img/ic_houseGoodsDetail_zp@2x.png"/>
          <span>正品保障</span>
        </div>
        <div class="item">
          <img class="ic" src="../../assets/img/ic_houseGoodsDetail_js@2x.png"/>
          <span>极速发货</span>
        </div>
        <div class="item">
          <img class="ic" src="../../assets/img/ic_houseGoodsDetail_xd@2x.png"/>
          <span>下单立省</span>
        </div>
        <div class="item">
          <img class="ic" src="../../assets/img/ic_houseGoodsDetail_sh@2x.png"/>
          <span>送货上门</span>
        </div>
      </div>

      <!-- 推荐商品 -->
      <div class="recommend" v-if="product_list.length">
        <div class="title">
          <div class="title">更多推荐</div>
          <div class="sub-title">
            <img class="ic" src="@/assets/img/goods_detail/ic_box.png" alt>
            <span>适用</span><span class="apt">{{apply_info}}</span>
          </div>
        </div>
        <div class="list">
          <div class="product-wrap">
            <div class="product" :class="{wide: product_list.length == 2}" @click="navigateToGoodsDetail(product)" v-for="product in product_list">
              <img class="img" :src='imgDomain+product.image'>
              <div class="name text_ellipsis">{{product.name}}</div>
              <div class="price"><span>¥</span>{{ utils.splitDec(product.discount_price).integer }}<span>.{{utils.splitDec(product.discount_price).decimal || '00'}}</span></div>
            </div>
            <div class="hint" v-if="product_list.length > 2">
              <van-icon class="arrow" name="arrow-left" size="0.25rem"/>
              <div class="txt">没有更多了</div>
            </div>
          </div>
        </div>
      </div>

      <div class="detail">
        <div class="box" v-if="showDetail()">
          <div class="til">商品参数</div>
          <div class="main1">
            <div class="item goods-param" v-for="(item,index) in detail.detail" v-if="!['名称', '商品名称'].includes(item.key)" :key="index">
              <div class="attr">{{ item.key }}</div>
              <div class="val">{{ item.value }}</div>
            </div>
          </div>
        </div>
        <div class="box" v-if="detail.info && detail.info.install_location_image">
          <div class="til">房间安装位置</div>
          <img @click="showBigPic(detail.info.install_location_image)" class="structure-img" :src="imgDomain + detail.info.install_location_image"/>
        </div>
        <div class="box" v-if="detail.scheme_install_pic"> <!--todo 原本在custom_detail里获取安装图-->
          <div class="til">安装结构图</div>
          <img @click="showBigPic(detail.scheme_install_pic)" class="structure-img" :src="imgDomain + detail.scheme_install_pic"/>
          <img class="magnifying-lens" src="@/assets/img/goods_detail/lens.png" alt>
        </div>
        <div class="box" v-if="(detail.scheme_type && detail.scheme_type !== 'YMJ')||detail.info.scheme_type">
          <div class="til">定制详情</div>
          <div class="main2">
            <table>
              <tr v-if="custom_detail.all_product_count">
                <td rowspan="2">主材</td>
                <td>展开总面积</td><td>{{ custom_detail.all_product_area }} m²</td>
              </tr>
              <tr v-if="custom_detail.all_product_count">
                <td>构件数量</td><td>{{ custom_detail.all_product_count }} 个</td>
              </tr>
              <tr v-for="(item,index) in custom_detail.door_products" :key="index">
                <td v-if="!index" :rowspan="custom_detail.door_products.length">门</td>
                <td>{{ item.product_name }}</td><td>{{ item.product_count }} {{ item.product_unit }}</td>
              </tr>
              <tr v-for="(item,index) in custom_detail.zj_products" :key="index+1">
                <td v-if="!index" :rowspan="custom_detail.zj_products.length">功能组件</td>
                <td>{{ item.product_name }}</td><td>{{ item.product_count }} {{ item.product_unit }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="box" v-if="detail.scheme_type === 'YMJ'">
          <div v-for="(chest,index) in detail.serial_array"  :key="index">
            <div class="til2">{{chest.scheme_name}}</div>
            <div class="toDetail" @click="toChestDetail(chest)">查看详情 <span class="icon dk-iconfont">&#xe63b;</span></div>
            <img class="structure-img" :src="imgDomain + chest.scheme_pic"/>
          </div>
        </div>
        <div class="box" v-if="detail.info.intro || type === 1 || type === 2">
          <div class="til">商品介绍</div>
          <div class="rich-text" v-html="detail.info.intro"/>
          <div class="intro-img" v-if="type === 1 || type === 2">
            <img src="../../assets/img/goods_detail/goods-detail-1.jpg" alt="">
            <img src="../../assets/img/goods_detail/goods-detail-2.jpg" alt="">
            <img src="../../assets/img/goods_detail/goods-detail-3.jpg" alt="">
            <img src="../../assets/img/goods_detail/goods-detail-4.jpg" alt="">
            <img src="../../assets/img/goods_detail/goods-detail-5.jpg" alt="">
            <img src="../../assets/img/goods_detail/goods-detail-6.jpg" alt="">
            <img src="../../assets/img/goods_detail/goods-detail-7.jpg" alt="">
          </div>
        </div>
        <div class="box" v-if="(detail.scheme_type||detail.info.scheme_type) && detail.scheme_type !== 'YMJ'  && !(env === 'ios' && !(/^http(s?):\/\/h5-test.mofanghouse.com/).test(location.origin))">
          <div class="til">商品BOM</div>
          <div class="bom-list">
            <div class="item" @click="jumpProductDetail(custom_detail_origin, 0, custom_detail.plate_price)">
              <div>·   柜体构件明细</div>
              <div class="val">￥{{ custom_detail.plate_price || '0.00' }}</div>
              <span class="icon dk-iconfont">&#xe63b;</span>
            </div>
            <div class="item" @click="jumpProductDetail(custom_detail_origin, 1, custom_detail.zj_price)">
              <div>·   功能组件明细</div>
              <div class="val">￥{{ custom_detail.zj_price || '0.00' }}</div>
              <span class="icon dk-iconfont">&#xe63b;</span>
            </div>
            <div class="item" @click="jumpProductDetail(custom_detail_origin, 2, custom_detail.wujin_price)">
              <div>·   五金附件明细</div>
              <div class="val">￥{{ custom_detail.wujin_price || '0.00' }}</div>
              <span class="icon dk-iconfont">&#xe63b;</span>
            </div>
            <div class="item" @click="jumpProductDetail(custom_detail_origin, 3, custom_detail.door_price)">
              <div>·   滑动门明细</div>
              <div class="val">￥{{ custom_detail.door_price || '0.00' }}</div>
              <span class="icon dk-iconfont">&#xe63b;</span>
            </div>
            <div class="item" @click="jumpProductDetail(custom_detail_origin, 4, custom_detail.shoukou_price)">
              <div>·   收口附件明细</div>
              <div class="val">¥{{ custom_detail.shoukou_price || '0.00' }}</div>
              <span class="icon dk-iconfont">&#xe63b;</span>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="til">下单须知</div>
          <div class="rich-text buy-intel" v-html="buyInfo"/>
        </div>
        <div class="box">
          <div class="til">安全提示</div>
          <div class="rich-text buy-intel" v-html="safetyTips"/>
        </div>
      </div>
    </div>

    <div class="bottom-container" v-if="detail.info.is_delete == 0 || [null, undefined].includes(detail.info.is_delete)">
      <div class="pri">
        <div class="num">产品价格 &nbsp; <span>¥ {{ gross }}</span></div>
      </div>
      <div class="cart-box">
        <div class="count" v-if="cartCount">{{ cartCount }}</div>
        <img class="cart" @click="toCart" src="../../assets/img/ic_HouseCaseDetail_cart@2x.png"/>
      </div>
      <div class="bt" @click="addProductCart()">加入购物车</div>
    </div>

    <div class="bottom-inform" v-else-if="detail.info.is_delete == 1">商品已下架</div>

    <coupon
      :show.sync="isShowCoupon"
      :coupon_info="selected_coupon_info"
    ></coupon>

    <cover ref="hintCover" :show.sync="showHintCover"></cover>

  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import store from '../../vuex/store';
import utils from '../../jslib/utils'
import Coupon from "./merc_coupon/merc_coupon"
import {
  getProductDetail,
  getColorList,
  addProductCart,
  addProductCartMall,
  addProductCartCustom,
  collectProduct,
  collectProductMall,
  collectProductCustom,
  getComplete,
  collect, cancelCollect,
  userEventLog
} from '@/api/api.js'
import Cover from "../../component/cover/cover"

export default {
  store,
  components: {Cover, Coupon},
  data() {
    return {
      id: '',
      detail: { info: {},},
      couponList: [],
      product_list: [],            // 推荐的商品列表,只有整配产品才会返回
      apply_info: '',              // 推荐的产品适用于XXX,只有整配产品才会返回
      custom_detail_origin: {},
      custom_detail: {},
      cartCount: 0,
      colorList: [],
      colorInd: -1,
      standardList: [],
      standardInd: -1,
      isMoreColor: false,
      num: 1,
      deliver_info: '',
      deliver_info_selected: '',

      utils: utils,
      refreshKey: 0,

      singlePrice: '0.00',
      showOriginPrice: true,
      originPrice: '0.00',
      gross: '0.00',

      type: '',
      from: '',                 //  1-商城   2-整配   3-定制
      decorate_product_id: '',
      product_id: '',

      selected_coupon_info: {},
      fromShoppingCartStandardId: null,

      isShowCoupon: false,

      showHintCover: false,

      // 下单须知
      buyInfo: '<b>关于色差</b><p>魔方屋商品图片均对应实物材质及花色样板，但由于显示设备、拍摄技术、图片色彩、光线等因素影响，商品图片和实物颜色可能会有微小差异，您可到魔方屋指定的样板空间确认实物颜色，再行提交订单。商品材质与花色以展示实物为准，如您介意，请您谨慎购买。</p><p><br></p><b>订单信息</b><p>请您仔细核对订单信息，包括所有商品的尺寸、花色、功能需求等，确认无误后再提交订单。如因您的疏忽而造成的尺寸输入、花色选择、功能添加等错误，致使商品送达后无法满足使用要求，由此产生的额外加工及多次物流、上门送货和安装服务等相关费用，将由您自行承担责任。</p><p><br></p><b>送货信息</b><p>提交订单前，请您仔细核对联系人、联系方式、送货时间与送货详细地址等是否准确无误，因上述信息添加错误或不完整，致使商品不能及时送达，并由此可能产生的多次送货及服务费，将由您自行承担责任。</p><p><br></p><b>关于货期</b><p>定制类家具商品，存在与您再次沟通方案、确定方案甚至需要区域运营服务商上门复尺等情况，系统预约的上门安装日期，可能会出现变动或延长，具体按照您与魔方屋客服沟通确定的送货安装时间为准。</p><p><br></p><b>犹豫期退单</b><p>魔方屋在商品发货前为您提供免责退款期，即“犹豫期”，在系统订单显示“已发货”状态之前的任意时间（发货一般会在送货安装日期前3天），您有权对包括定制家具商品在内的家具商品无条件退款或更改送货安装日期。但满足此项服务的前提条件是您下单时选择的送货安装日期多于3天以上（不含3天）。您在犹豫期内申请退款，魔方屋无条件原路退还订单款，仅需扣除第三方支付手续费及相关结算费用，金额为退款总金额的0.8%。除此以外，我们不收取任何费用。您可在个人中心“我的订单”内申请操作。</p><p><br></p><b>配送安装</b><p>大件物流运输方式不同于小件快递，大件家具商品魔方屋可以支持“免费送货上门并安装”服务，具体以商品页面公示为准。偏远地区或者行车不便的小区、没有电梯的楼房，需要根据当地的收费标准额外加收部分搬运费服务费。下单前请您认真了解收费标准，或咨询魔方屋客服。</p><p><br></p><b>关于签收</b><p>为保障您的权益，建议您一定要在送货人员在场的情况下验视，在确定货物完好无损后再签收。如在验收过程中发现外包装破损、商品出现破损、少件等问题，请自行拍照并让送货人员签字，保留相关证据，联系魔方屋客服进行核实处理；如您未进行验视即做签收，将默认为您已经对商品进行了当面验收，我们将无法对运输过程中造成的货物损坏进行合理判责。如正常签收后发现商品有破损情况，您有可能承担一部分费用。</p><p><br></p><b>关于退换货</b><p>商品因严重质量问题您可申请退换货。您需向魔方屋客服提供证据，若客服收到证据后，确认商品本身确实存在质量问题，会为您办理退换货/保修。但因大件家具物流成本极高，如出现零部件质量问题，优先以换件、补件为主；玻璃制品和易损制品局部损坏，可由魔方屋直接补寄，无需全部退回。您的退/换货需求，区域运营服务商无权代表魔方屋作出任何答复，请您联系魔方屋客服协商处理。</p><p><br></p><b>全额免单</b><p>如您担心商品品质可能未达到商品宣传中所公开的质量标准，我们支持您向国家权威检测部门对商品进行检测，如果检测报告认定商品未达标，我们将依据检测报告并参考魔方屋供应链管理的相关规则严厉追究有关供应商责任，并解除供应链合作。同时对您协助我们进行的监督与反馈给予高额奖励。</p>',
      safetyTips: '<p><ul><li>请勿让儿童躲到柜体内捉迷藏或攀爬、悬挂在抽屉、柜门或搁板上，以免带来伤害。</li><li>教育孩子不要贴近家具锐角、镜子、玻璃、金属部件位置玩耍，避免不慎伤害。</li><li>家具表面日常防水，但请勿浸泡。边缘处不要久置湿毛巾。</li><li>受商品设计承重限制，请不要站立在抽屉上，请不要在承重的情况下同时打开多个抽屉；墙外独立柜类家具，沉重物品请放置柜底部，防止家具重心不稳倾倒。防范家具倾倒的最好方法是把家具固定在墙壁上。</li><li>移动家具时，应搬出柜内物品，门、屉要封紧，以免家具倾斜、部件滑落伤人。搬动时切忌硬拖猛推，以免造成家具松动、断裂。</li></ul></p>',

      env: 'web',    // todo: ios暂时隐藏定制/调整、BOM详情 (ios对接完成后开放)
      location: window.location,
      isInApp: ['android', 'ios'].includes(utils.getEnv())
    };
  },
  created() {
    this.setToken()
  },
  mounted() {
    let {from, f, id, product_id, decorate_product_id} = this.$route.query
    if (from != 1 && from != 2 && from != 3) from = f

    from = Array.isArray(from) ? from[from.length-1] : from
    this.from = Number(from)

    this.id = id || product_id || decorate_product_id                        // todo: product_id, decorate_product_id 在本页面已弃用，移动生产环境更新后删除
    this.product_id = [1, 3].includes(+from) ? this.id : ''
    this.decorate_product_id = +from === 2 ? this.id : ''

    this.fromShoppingCartStandardId = this.$route.query.standard_id
    this.fromShoppingCartColorId = this.$route.query.color_id

    this.env = utils.getEnv()

    this.network().getProductDetail()
    // this.network().getColorList()

    this.isUiWebView
  },
  watch:{
    colorInd(){
      this.setSinglePirce()
      this.getDeliverInfo()
    },
    standardInd(){
      this.setSinglePirce()
      this.getDeliverInfo()
    },
    standardList(){
      this.setSinglePirce()
    },
    detail(){
      this.setSinglePirce()
    },

    num(){
      this.countGross()
    },
    singlePrice(){
      this.countGross()
    }
  },
  methods: {
    shareProduct(){

      let title = this.detail.info.name || this.detail.scheme_name
      let desc  = '魔方屋有一个不错的商品，赶快来看看吧！'
      let url   = 'HouseGoodsDetail?from='+this.from+'&f='+this.from+'&id='+this.id
      let picUrl = this.detail.info.image || this.detail.scheme_pic

      this.$refs.hintCover.openApp(undefined,undefined,undefined,'shareToFriends') || this.shareURL( title, desc, url, picUrl)
    },
    toCart(){
      if(this.checkLogin()) this.toShoppingCart()
    },

    // --- 选择规格/颜色 ---

    selectedStandarFromCart(standardId){
      if(!standardId) return
      for(let i in this.standardList){
        if(standardId == this.standardList[i].standard_id){
          this.getColorStandardInd(+i, this.standardList[i].stocks)
        }
      }
    },
    selectedColorFromCart(colorId){
      if(!colorId) return
      for(let i in this.colorList){
        if(colorId == this.colorList[i].color_id){
          this.colorInd = +i
        }
      }
    },
    selectColor(index, standarId){
      this.colorInd = index
      this.detail.info.standard_id = standarId
    },
    getColorStandardInd(index, stocks) {
      if (!stocks) return
      this.standardInd = index
    },
    preSelectColor(isPreSelected, index, standar_id){
      if(this.colorInd >= 0){
        return this.colorInd === index
      }else{
        if(isPreSelected) this.selectColor(+index, standar_id)
        return isPreSelected
      }
    },
    preSelectStander(isPreSelected, index, stocks){
      if(this.standardInd >= 0){
        return this.standardInd === index
      }else {
        if(isPreSelected) this.getColorStandardInd(+index, stocks)
      }
    },

    madeCustom(isCreateScheme) {
      let item = this.detail.info
      if (!item.id) item = this.detail
      this.jump2DDemandOperateActivity(this.type==1, isCreateScheme, item.scheme_type + (item.scheme_b_type ? '-'+item.scheme_b_type : ''), this.decorate_product_id, this.product_id)
    },
    toChestDetail(detail){
      store.state.pageParam = detail
      this.navigateTo('/chestDetail')
    },
    addProductCart(){
      const { product_id, decorate_product_id, type, colorList, colorInd, detail, num, standardList, standardInd} = this
      const standard_id = standardInd >= 0 ? standardList[standardInd].standard_id : detail.info.standard_id
      const color_id = detail.info ? detail.info.color_id : ''
      let res = {}
      switch (this.from) {
        case 1:
          this.network().addProductCartMall({product_id, standard_id, count: num})
          break
        case 2:
          const cart_list = []
          const cart_item = { product_id: decorate_product_id, type, color_id, standard_id}

          if(!cart_item.standard_id) cart_item.standard_id = detail.info ? detail.info.standard_id : null
          for(var i = 1; i <= num; i++) cart_list.push(cart_item)

          const color_id_obj = colorInd>=0 ? colorList[colorInd] : ''
          const param = { cart_list, color_id: color_id_obj.color_id, program_id: detail.info.decorate_id}

          this.network().addProductCart(param)
          break
        case 3:
          this.network().addProductCartCustom({scheme_id:this.detail.id,count:num})
          break
        default:
          break
      }
    },
    collectProduct(){

      //  1-商城   2-整配   3-定制
      //  收藏项目类型: 'shop_product'-商城商品,'decorate_product'-整配产品,'customized_product'-定制产品,'decorate_program'-整配方案
      let type = (new Map([ [1, 'shop_product'], [2, 'decorate_product'], [3, 'customized_product'] ])).get(this.from)
      let id = this.from === 2 ? this.decorate_product_id : this.product_id

      if(this.detail.is_collect){
        this.network().cancelCollect(id, type)
      }else {
        this.network().collect(id, type)
      }
    },
    handle3DProductInfo(data){    // 处理3D生成的定制柜类商品信息 (衣帽间)
      if(!(data && data.scheme_type === 'YMJ')) return false

      let {scheme_price, scheme_dis_price} = data

      this.detail = data
      this.singlePrice = scheme_dis_price
      this.originPrice = scheme_price

      this.detail.info = {
        discount_price: scheme_dis_price,
        original_price: scheme_price
      }
      this.type = 2

      return true
    },
    countGross(){
      this.gross = (+this.singlePrice * +this.num).toFixed(2)
    },
    setSinglePirce(){
      let schemeDisPrice = this.detail.serial_array && this.detail.serial_array.scheme_dis_price                            // 打折后的价格
      let standarPrice = this.standardInd>=0 ? this.standardList[this.standardInd].price : this.detail.info.discount_price  // 不同规格的价格

      this.singlePrice = standarPrice || schemeDisPrice     // 优先使用不同规格的价格(如果有的话)

      this.showOriginPrice = true
      this.originPrice = this.standardList&&this.standardList[this.standardInd]&&this.standardList[this.standardInd].original_price || this.detail.info.original_price || this.detail.serial_array&&this.detail.serial_array.scheme_price
      if(+this.originPrice < +this.singlePrice || [0, NaN].includes(+this.originPrice)) this.showOriginPrice = false

    },

    // 获得发货信息
    getDeliverInfo(){
      let deliver_info = this.standardList[this.standardInd] && this.standardList[this.standardInd].deliver_info ||
        this.colorList[this.colorInd] && this.colorList[this.colorInd].deliver_info ||
        this.deliver_info
      this.deliver_info_selected = deliver_info
      return deliver_info
    },

    // 路由发生改变时
    onRouteChange() {
      console.log('视图更新')
      if(sessionStorage.getItem('get_wx_code_refresh')){
        this.$router.go(0)
        sessionStorage.removeItem('get_wx_code_refresh')
      }
    },

    // 记录点击推荐
    recordClick(id){
      this.network().userEventLog(id)
    },

    navigateToGoodsDetail(item) {
      const {from, id, standard_id, color_id, recommend_id} = item
      let url = 'houseGoodsDetail?from=' + from

      this.recordClick(recommend_id)

      switch (Number(from)) {
        case 1: // 易居集市（商城）
        case 3: // 易柜定制
          url += '&product_id=' + id
          break
        case 2: // 易家整配
          url += '&decorate_product_id=' + id
          break
      }
      if(standard_id !== undefined) url += '&standard_id=' + standard_id
      if(color_id !== undefined) url += '&color_id=' + color_id
      location.href = url
    },

    showCoupon(item){
      this.selected_coupon_info = item
      this.isShowCoupon = !this.isShowCoupon
    },

    // 渲染数据
    showDetail(){
      let {detail} = this

      if(!detail.detail) return

      let oneName = detail.detail.length===1&&['名称', '商品名称'].includes(detail.detail[0].key)
      let twoName = detail.detail.length===2 && ['名称', '商品名称'].includes(detail.detail[0].key) && ['名称', '商品名称'].includes(detail.detail[1].key)

      return detail.detail&&detail.detail.length && !(oneName || twoName)
    },

    // 网络请求
    network() {
      return {
        getProductDetail: async () => {
          const { from, decorate_product_id, product_id } = this
          let param = { from }
          switch (from) {
            case 1: // 易居集市（商城）
            case 3: // 易柜定制
              Object.assign(param,{product_id})
              break
            case 2: // 易家整配
              Object.assign(param,{decorate_product_id})
              break
          }

          let {data} = await getProductDetail(param)

          console.log('产品详情', data)

          data = utils.dealWithErrorDate(data)     // fixme 后台返回数据有误

          let {code, message} = data
          if(code === 200){
            this.handler().getProductDetail_(data.data)
          }else {
            this.$uihelper.toast(message)
          }

        },
        getComplete: async (type, scheme_id) => {
          if(type=='ZH') type='ZHG'
          if(this.detail.scheme_b_type=='BGDG') type = 'ZHGBGDG'

          let {data} = await getComplete(type, { scheme_id })

          console.log('结算'+type, data)
          this.custom_detail_origin = data.data
          this.custom_detail = JSON.parse(JSON.stringify(data.data))

          const { plate_products, score_products, wujin_products, door_products, door } = this.custom_detail

          // 主材（总面积｜构件数量）
          let all_product_area = 0
          if (plate_products) {
            plate_products.forEach((item) => {
              all_product_area += +item.product_area
            })
          }
          this.custom_detail.all_product_area = all_product_area.toFixed(2)

          this.custom_detail.all_product_count = 0
          if(score_products){
            score_products.forEach((item) => {
              this.custom_detail.all_product_count += item.product_count
            })
          }

          // 拉篮 裤抽
          let countItem = (productName) => {
            if(!(this.custom_detail && this.custom_detail.zj_products)) return
            let firstItem = undefined
            let count = 0
            for(let i = 0; this.custom_detail.zj_products.length > i; i++) {
              let item = this.custom_detail.zj_products[i]
              if (item.product_name === productName) {
                if (!firstItem) firstItem = this.custom_detail.zj_products[i]
                if (count > 0){
                  this.custom_detail.zj_products.splice(i, 1)
                  i --
                }
                count += item.product_count
              }
            }
            if(firstItem) firstItem.product_count = count
          }
          countItem('拉篮')
          countItem('裤抽')

          // 功能组件（衣通杆）
          let ytgList = []
          let ytgCount = 0
          if(wujin_products){
            wujin_products.forEach((item) => {
              const index = item.product_no.indexOf('W06-01')
              if(index >= 0){
                ytgCount += item.product_count
                ytgList.push(item)
              }
            })
          }
          if(ytgList.length){
            ytgList[0].product_count = ytgCount
            this.custom_detail.zj_products.push(ytgList[0])
          }

          // 门（数量｜移门缓冲器）
          let ymhcqItem = ''
          if (door_products){
            door_products.forEach((item) => { if(item.product_no === 'W04-20-XX-00') ymhcqItem = item })
          }
          this.custom_detail.door_products = []
          if(ymhcqItem) this.custom_detail.door_products.push(ymhcqItem)
          if(door && door.door_has_count){
            this.custom_detail.door_products.push({
              product_name: '移动门',
              product_count: door.door_has_count,
              product_unit: '扇'
            })
          }
        },
        getColorList: async () => {
          let {data} = await getColorList({decorate_product_id:this.decorate_product_id})
          console.log('花色列表(暂不使用)', data)
          this.colorList = data.data.color_list
        },
        getStandardList: async (product_id) => {
          let {data} = await getStandardList({product_id})
          console.log('商品类规格', data)
          this.standardList = data.data.color_list
          if(this.fromShoppingCartStandardId) this.selectedStandarFromCart(this.fromShoppingCartStandardId)    // 如果从购物传入别的规格，显示别的规格
        },
        addProductCartMall: async (param) => {
          const { data } = await addProductCartMall(param)
          console.log('加入购物车(商城)', data)

          let {code, message} = data

          if(code == 200){

            this.$uihelper.toast('加入成功');
            // this.cartCount += 1
            this.cartCount += this.num

          }else{

            this.$uihelper.toast(message)

          }

        },
        addProductCart: async (param) => {
          const { data } = await addProductCart(param)
          console.log('加入购物车(整配)', data)

          let {code, message} = data

          if(code == 200){
            this.$uihelper.toast('加入成功');
            // this.cartCount += 1
            this.cartCount += this.num
          }else{
            this.$uihelper.toast(message)
          }

        },
        addProductCartCustom: async (param) => {
          const { data } = await addProductCartCustom(param)
          console.log('加入购物车(定制)', data)

          let {code, message} = data

          if(code == 200){
            this.$uihelper.toast('加入成功');
            // this.cartCount += 1
            this.cartCount += this.num
          }else{
            this.$uihelper.toast(message)
          }

        },
        /* collectProduct: async () => {
           let {data} = await collectProduct({type: 1, decorate_product_id: this.decorate_product_id})
           console.log('收藏or取消（整配）', data)
           this.detail.is_collect = this.detail.is_collect ? 0 : 1
         },
         collectProductMall: async () => {
           let {data} = await collectProductMall({product_id: this.product_id, collect_type: this.detail.is_collect ? 'cancel' : 'collect'})
           console.log('收藏or取消（商城）', data)
           this.detail.is_collect = this.detail.is_collect ? 0 : 1
         },
         collectProductCustom: async () => {
           let {data} = await collectProductCustom({works_id: this.product_id, collect_type: this.detail.is_collect ? 'cancel' : 'collect'})
           console.log('收藏or取消(定制)', data)
           this.detail.is_collect = this.detail.is_collect ? 0 : 1
         },*/
        collect: async (id, type) => {
          let {data} = await collect({item_id: id, item_type: type})
          console.log('收藏', data)
          this.$uihelper.toast('收藏成功')
          this.detail.is_collect = 1
        },
        cancelCollect: async (id, type) => {
          let {data} = await cancelCollect({item_id: id, item_type: type})
          console.log('取消收藏', data)
          this.$uihelper.toast('取消收藏')
          this.detail.is_collect = 0
        },
        userEventLog: async (recommend_id) => {
          let data = {
            data: JSON.stringify([{
              event_key:'040101',
              event_value: {
                recommend_id,
                start_time: (new Date().getTime()/1000).toFixed(0)
              }
            }])
          }
          let {date} = await userEventLog(data)
          console.log('记录', date)
        },
      };
    },
    handler() {
      return {
        couponData: (data) => {

          // 测试数据
          let testData = [
            {id: 9999,
              name: '9折优惠券',
              type: 0,           // 优惠券类型: 0-折扣券，1-满减券
              discount_type: 0   // 折扣类型: 0-拼团折扣，1-普通折扣
            },
            {id: 9985, name: '85折优惠券'}
          ]

          // data = testData

          this.couponList = data
        },
        getProductDetail_ : (data) => {
          const { product_info, coupon_list, apply_info, product_list } = data
          this.handler().couponData(coupon_list)

          if( !product_info ) return
          if(this.handle3DProductInfo(product_info)) return     // 处理3D生成的定制柜类商品信息

          this.detail = product_info
          if(product_info.scheme_type) this.network().getComplete(product_info.scheme_type, this.product_id)

          const { info, color_info, cart_count, standard_info, deliver_info } = product_info
          this.cartCount = cart_count || 0
          this.colorList = color_info || []
          this.standardList = standard_info || []     // 规格信息
          this.product_list = product_list || []      // 推荐商品推荐
          this.apply_info = apply_info || []          // 推荐的产品适用于XXX,只有整配产品才会返回
          this.deliver_info = deliver_info            // 定制商品发货信息

          if( !info ){
            this.detail.info = {}
            this.type = 1
            return
          }

          if(this.from == 2){
            this.product_id = info.product_id
            this.detail.scheme_install_pic = this.detail.info.scheme_install_pic || ''
          }

          this.type = info.type || 2
          window.document.title = this.detail.info.name || this.detail.scheme_name
          if(info.scheme_type) this.network().getComplete(info.scheme_type, this.product_id)
          if(this.fromShoppingCartStandardId) this.selectedStandarFromCart(this.fromShoppingCartStandardId)    // 如果从购物传入别的规格，显示别的规格
          if(this.fromShoppingCartColorId) this.selectedColorFromCart(this.fromShoppingCartColorId)            // 从购物车带进来的花色

        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./houseGoodsDetail";
</style>
